import React from "react";

import { useSelector, useDispatch } from "react-redux";

import { push } from "connected-react-router";

import ErrorPage from "../../ui/error";

import errorRed from "../../../assets/img/error-red.png";

import { usePageView } from "../../../utils/google-analytics-handler";

const Error = () => {
  usePageView();
  const dispatch = useDispatch();
  const { email, role } = useSelector(state => state.user.current);
  const pages = [{ name: "Conciliaciones", path: "/", active: false }];
  if (role === "Admin") pages.push({ name: "Usuarios", path: "/users", active: false });

  const actions = [{ name: "Ir a la home", action: () => dispatch(push("/")) }];

  return (
    <ErrorPage
      title="Página no encontrada"
      subtitle="Oopps. La página solicitada no existe."
      text="Verifique la URL o regrese a la página principal."
      image={errorRed}
      email={email}
      role={role}
      pages={pages}
      actions={actions}
    />
  );
};

export default Error;
